module.exports = {"431123100":"泷泊镇","431123101":"江村镇","431123102":"五里牌镇","431123103":"茶林镇","431123104":"何家洞镇","431123105":"麻江镇","431123206":"塘底乡","431123207":"上梧江瑶族乡","431123208":"理家坪乡","431123209":"五星岭乡","431123210":"打鼓坪乡","431123400":"双牌打鼓坪林场","431123401":"双牌五星岭林场","431123402":"阳明山国家森林公园管理局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431123.json
// module id = 1907
// module chunks = 0